import { Link } from 'react-router-dom';
import { LinkedinLogo, XLogo, EnvelopeSimple, MapPin } from '@phosphor-icons/react';
import { CATEGORIES, CONTACT_EMAIL, LINKEDIN_URL, X_URL, HOME_SLUGS } from '../../data/site';

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-line bg-ink">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 sm:grid-cols-2 lg:grid-cols-4 lg:px-10 lg:py-20">
      <div>
        <div className="flex items-center gap-2.5">
          <span className="flex h-6 w-6 items-center justify-center bg-volt font-display text-sm font-black text-ink">V</span>
          <span className="font-display text-sm font-bold tracking-[0.18em] text-parchment">VOX MERIDIAN</span>
        </div>
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-steel">
          The global RFQ marketplace for industrial &amp; business services — 65 services, 10 markets, founder oversight on every match.
        </p>
        <div className="mt-5 flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-steel">
          <MapPin size={14} className="text-volt" /> Global · SG-first
        </div>
      </div>
      <div>
        <p className="mono-label mb-5">Pages</p>
        <ul className="space-y-3 text-sm">
          <li><Link data-testid="footer-link-providers" to="/providers" className="text-steel transition-colors duration-200 hover:text-volt">For Providers</Link></li>
          <li><Link data-testid="footer-link-buyers" to="/buyers" className="text-steel transition-colors duration-200 hover:text-volt">For Buyers</Link></li>
          <li><Link data-testid="footer-link-guides" to="/guides" className="text-steel transition-colors duration-200 hover:text-volt">Guides</Link></li>
          <li><Link data-testid="footer-link-directory" to="/directory" className="text-steel transition-colors duration-200 hover:text-volt">Provider Directory</Link></li>
          <li><Link data-testid="footer-link-about" to="/about" className="text-steel transition-colors duration-200 hover:text-volt">About &amp; Contact</Link></li>
          <li><Link data-testid="footer-link-privacy" to="/privacy" className="text-steel transition-colors duration-200 hover:text-volt">Privacy</Link></li>
          <li><Link data-testid="footer-link-terms" to="/terms" className="text-steel transition-colors duration-200 hover:text-volt">Terms</Link></li>
          <li><Link data-testid="footer-link-advertise" to="/advertise" className="text-steel transition-colors duration-200 hover:text-volt">Advertise</Link></li>
        </ul>
      </div>
      <div>
        <p className="mono-label mb-5">Services</p>
        <ul className="space-y-3 text-sm">
          <li><Link data-testid="footer-link-all-services" to="/services" className="font-semibold text-parchment transition-colors duration-200 hover:text-volt">All Services — 65 services</Link></li>
          {CATEGORIES.filter((c) => HOME_SLUGS.includes(c.slug)).map((c) => (
            <li key={c.slug}>
              <Link
                data-testid={`footer-link-${c.slug}`}
                to={`/services/${c.slug}`}
                className="text-steel transition-colors duration-200 hover:text-volt"
              >
                {c.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <p className="mono-label mb-5">Contact</p>
        <ul className="space-y-3 text-sm">
          <li>
            <a data-testid="footer-contact-email" href={`mailto:${CONTACT_EMAIL}`} className="flex items-center gap-2 text-steel transition-colors duration-200 hover:text-volt">
              <EnvelopeSimple size={15} /> {CONTACT_EMAIL}
            </a>
          </li>
          <li>
            <a data-testid="footer-link-linkedin" href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-steel transition-colors duration-200 hover:text-volt">
              <LinkedinLogo size={15} /> LinkedIn
            </a>
          </li>
          <li>
            <a data-testid="footer-link-x" href={X_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-steel transition-colors duration-200 hover:text-volt">
              <XLogo size={15} /> X
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-line">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-6 font-mono text-xs uppercase tracking-[0.2em] text-steel/60 sm:flex-row sm:items-center sm:justify-between lg:px-10">
        <span>© 2026 Vox Meridian · Singapore</span>
        <span className="flex items-center gap-2">
          <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-volt" />
          Concierge phase live
        </span>
      </div>
    </div>
  </footer>
);
